import { createFileRoute } from "@tanstack/react-router";
import UsersDataGrid from "@/views/users/UsersDataGrid.tsx";
import AppCard from "@/components/AppCard.tsx";
import { useEnums } from "@/store/hooks.ts";

export const Route = createFileRoute("/_dashboard/users")({
  component: Users,
});

function Users() {
  const enums = useEnums();

  return (
    <AppCard title="users">
      <UsersDataGrid />
    </AppCard>
  );
}
